module.exports = __webpack_public_path__ + "static/media/Ahri.4979c179.png";